<template>
    <div id="all">
      <!-- <Header /> -->
      <h2>中文知识网账号注销协议</h2>
      <p>
        <span>【特别说明】</span>
        尊敬的用户，在您正式开始下一步中文知识网账号注销流程前，我们先为您做出如下特别说明：
        <span>注销中文知识网账号后，您将无法再以此账号登录和使用中文知识网及其关联公司（以下简称“我们”或者“中文集团”）的相关产品与服务（以下简称为“中文集团旗下的产品与服务”，例如“中文知识网”、“百科在线”、“百家在线”、“投审稿系统”、“采编名片”等），中文集团也将同时终止为该账号提供我们的高品质、多元化的产品与服务，这同时也不可避免地会给您的售后维权带来不便。且中文知识网账号一旦注销完成，将无法恢复。请您在注销前慎重考虑。</span>
      </p>
      <p>若您经过慎重考虑后仍执意决定注销中文知识网账号，请您务必先行仔细阅读和充分理解《中文知识网账号注销协议》，在同意全部内容后，按照我们的注销操作指引点击进行下一步操作，您勾选本注销协议并点击下一步注销操作的行为即视为您已经同意签署和遵守本协议全部内容。如您在注销后需要再次使用我们的服务时，欢迎您使用手机号码或中文集团允许的其他方式重新注册。</p>
      <p>（如您执意决定注销中文知识网账号，请继续向下阅读）</p>
      <p style="marginTop:30px;"><span>一、您需要首先知悉的是：账号注销将会对您产生如下影响：</span></p>
      <p>1.中文知识网账号一旦注销，您将无法登录、使用该账号（也包括无法再使用该账号作为第三方账号登录其他产品），也就是说您将无法再以此账号登录/使用/继续使用中文集团旗下的相关产品与服务；</p>
      <p>2.中文知识网账号一旦注销，您曾通过该账号登录、使用的中文集团旗下的产品与服务下的所有内容、信息、数据、记录将会被删除或匿名化处理，您也无法再检索、访问、获取、继续使用和找回，也无权要求我们找回（但法律法规另有规定或监管部门另有要求的除外），包括：</p>
      <p>•该账号下的个人资料（例如：头像、昵称等）及绑定信息（例如：绑定手机号、邮箱等）；</p>
      <p>•该账号下的您的个人信息（同时您亦不再享有《中文知识网隐私政策》中约定的您的用户权利，但法律法规另有规定的除外）；</p>
      <p>•该账号曾发表的所有内容（例如：音频、图片、照片、评论、互动、点赞等）；</p>
      <p>•其他所有内容、信息、数据、记录。</p>
      <p>3.您申请账号注销的行为即表明您同意放弃该账号在中文集团旗下的产品与服务使用期间已产生的但未消耗完毕的权益及未来的预期利益。即中文知识网账号一旦注销，我们将会对该账号下的全部权益做清除处理（如果有），包括：您在中文集团旗下的产品与/或服务中发布的内容未来的收益权益；</p>
      <p>您在中文集团旗下的产品与/或服务中的各类身份权益；</p>
      <p>您在中文集团旗下的产品与/或服务中已经购买的未到期的在线服务内容；</p>
      <p>其他已产生但未消耗完毕的权益或未来预期的收益。</p>
      <p>4.中文知识网账号一旦注销完成，将无法恢复（即使您在注销后以同一手机号码再次向我们申请注册中文知识网账号，此时该账号为新的用户账号。因此，<span>我们善意地提醒您在申请注销前对您认为需要备份的内容提前自行做好备份）；</span></p>
      <p>5.中文知识网账号一旦注销，您与我们曾签署过的相关用户协议、其他权利义务性文件等相应终止（但我们与您之间已约定继续生效的或法律法规另有规定的除外）；</p>
      <p>6.其他因中文知识网账号注销产生的结果。</p>
      <p style="marginTop:30px;"><span>二、在您向我们申请注销中文知识网账号之前或正在申请注销中文知识网账号的过程中，为保障您的账号安全和财产权益，请您先行检查与确保您申请注销的中文知识网账号已经同时满足以下几点，包括：</span></p>
      <p>1.该账号是通过我们的官方渠道注册、符合《中文知识网服务协议》及相关平台说明规范的账号，且为您本人注册的账号；</p>
      <p>2.该账号内无资金；</p>
      <p>3.该账号内无未处理完毕的认证或投稿，包括不限于：</p>
      <p>1)投审稿投稿中稿件。</p>
      <p>2)认证中的审核。</p>
      <p><span>4.上述问题您可首先尝试自行处理，如您无法处理的或在处理过程中有任何疑惑的，可联系中文知识网客服协助处理。</span></p>
      <p style="marginTop:30px;"><span>三、如何注销中文知识网账号？</span></p>
      <p>1.我们的官方渠道为您提供了在线的注销功能（如手机端中文知识网App的注销功能路径为：我的-帮助反馈-账号注销），您可以按照页面操作指引进行在线注销。当然，您也可以直接与我们的客服联系进行账号注销；</p>
      <p>2.本《中文知识网账号注销协议》中包含了账号注销对您权益产生的影响等多方面的内容阐述，请您仔细阅读与充分理解，在同意本《中文知识网账号注销协议》的全部内容后再进行下一步注销操作；</p>
      <p>3.为保障您的账号安全和财产权益，我们需要进行注销申请的身份验证（例如：验证账号绑定的手机号码等），以确保该账号真的是您本人注册的；</p>
      <p><span>4.账号注销的处理期限为15日，也就是说，在您已成功向我们提交了中文知识网账号注销申请后的15日内（从成功提交申请之时起算），账号将被注销（本协议另有约定的除外）。在前述15日内，您无法登录与使用该账号，亦无法使用该账号绑定的手机号码注册新账号；但是，在此期间内，您可以通过产品页面上的恢复功能（如手机端中文知识网App的恢复功能路径为：我的-帮助反馈-账号注销-申请恢复账号）或联系客服来恢复账号的正常使用；</span></p>
      <p>5.如超过上述第4点所述期限后，我们未收到您恢复账号的请求的，该账号将被永久注销。</p>
      <p>本协议未尽事宜，请参考《中文知识网服务协议》《中文知识网隐私政策》及注销过程中的平台相关规则、说明等。同时，您知悉并同意：即使您的中文知识网账号被注销了，也并不代表减轻或免除您应根据相关法律法规、相关协议、规则等（可能）需要承担的相关责任。</p>
      <p><span>如在中文知识网账号注销过程中有任何问题您无法处理的或在处理过程中有任何疑惑的，可联系中文知识网客服协助处理。</span></p>
      <p><span>本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本协议产生之争议，双方尽最大诚意进行友好协商，如果双方不能协商一致，均应依照中华人民共和国法律予以处理，并由北京市海淀区人民法院管辖。</span></p>
      <p style="textAlign:end; marginTop:20px;"><span>中文知识网</span></p>
    </div>
</template>

<script>
// import Header from '@/views/mobileView/detail/appUses/components/Header.vue'
export default {
     name:'jumpuseslogout',
    components: {
      // Header
    },
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    mounted() {

    },
    methods: {

    },
};
</script>

<style scoped lang="scss">
#all{
  padding: 20px;
  & h2{
    text-align: center;
    margin-bottom: 20px;
  }
  & p{
    text-indent: 20px;
    font-size: 15px;
    margin-bottom: 10px;
    & span{
      font-weight: bold;
    }
  }
}
</style>
